const Immersive3dTourPricingMethod = {
  BASE_PRICE_AND_PER_PANORAMA: 0,
  FLAT_FEE: 1,
  PER_SQUARE_FEET: 2,
};

export default Immersive3dTourPricingMethod;
